export default "__VITE_ASSET__v$4pZ17n__"